import React from "react";
import PropTypes from "prop-types";

// import deep-equal
import equal from "deep-equal";

// import store
import { connect } from "react-redux";

// import store actions
import {
  setAppTokenAsked,
  setAppTokenRetrieved,
  setArticle,
  setOpportunity,
  togglePreloader,
} from "../../store/actions";

// import constants
import { APP_TOKEN } from "../../helpers/constants";

// import services
import { getOpportunities } from "../../services/opportunityService";

// import utilities
import { isUnauthenticatedRequest } from "../../helpers/utilities";

// import common components
import Banner from "../../components/common/Banner";
import Leading from "../../components/common/Leading";
import Breadcrumbs from "../../components/common/Breadcrumbs";
import Section from "../../components/common/Section";
import Maper from "../../components/common/Maper";

// import custom components
import SlideArticle from "../../components/custom/articles/SlideArticle";
import ListOpportunity from "../../components/custom/opportunities/ListOpportunity";
import FilterOpportunity from "../../components/custom/opportunities/FilterOpportunity";
import { withRouter } from 'react-router-dom';

// import marker image
import { mkOpportunity } from "../../assets/images";
import { propTypes } from "react-bootstrap/esm/Image";

class Opportunities extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      // allOpportunities:[]
    };
  }

  componentDidMount() {
    try {
      this.props.onPreloaderToggled(true, "Chargement des opportunités");
      if (!localStorage.getItem(APP_TOKEN)) {
        this.props.onAppTokenAsked(true);
      } else {
        this.onGetOpportunities();
      }
    } catch (error) {
      console.log(error);
    }
  }

  componentDidUpdate(prevProps) {
    try {
      //Check props
      if (!equal(prevProps, this.props)) {
        if (this.props.tokenRetrieved && localStorage.getItem(APP_TOKEN)) {
          this.props.onAppTokenRetrieved(false);
          this.onGetOpportunities();
        } else if (this.props.tokenFailed) {
          this.props.onPreloaderToggled(false, "");
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  /**
   * Get opportunities.
   *
   */
  onGetOpportunities() {
    getOpportunities()
      .then((response) => {
        console.log({response})
        if (response && response.data) {
          this.props.onSetOpportunities(response.data);
          // this.setState({
          //   allOpportunities:response.data,
          // });
          setTimeout(() => {
            this.redirectToHomePage();
          }, 1000);
          this.onGetArticles();
        } else if (isUnauthenticatedRequest(response)) {
          this.props.onAppTokenAsked(true);
        } else {
          console.error(response, "GET OPPORTUNITIES ERROR");
        }
      })
      .catch((error) => {
        console.error(error, "GET OPPORTUNITIES ERROR");
      });
  }

  /**
   * Get articles.
   *
   */
  onGetArticles() {
    getOpportunities()
      .then((response) => {
        if (response && response.data) {
          this.props.onSetArticles(response.data);
          this.props.onPreloaderToggled(false, "");
        } else if (isUnauthenticatedRequest(response)) {
          this.props.onAppTokenAsked(true);
        } else {
          this.props.onPreloaderToggled(false, "");
          console.error(response, "GET ARTICLES ERROR");
        }
      })
      .catch((error) => {
        this.props.onPreloaderToggled(false, "");
        console.error(error, "GET ARTICLES ERROR");
      });
  }

  redirectToHomePage() {
    
    console.log("working data")
    this.props.history.push('/');
  }

  //*** handle scroll */

  //  handleScroll() {
  //   if (
  //     window.innerHeight + document.documentElement.scrollTop ===
  //     document.documentElement.offsetHeight
  //   ) {
      
  //     setFilteredResults(prevNumCards => prevNumCards + 5); 
  //   }
  // }
  
  // useEffect(() => {
  //   window.addEventListener('scroll', this.handleScroll);
  //   return () => {
  //     window.removeEventListener('scroll', handleScroll);
  //   };
  // }, []);

  render() {
    const { opportunities, articles, isPreloader } = this.props;
    // const {allOpportunities}=this.state;
    //  console.log("allOpportunities",allOpportunities);


    return (
      <React.Fragment>
        <div className="container">
       
        <div
          id="opportunities"
          className={`${isPreloader ? "d-none" : "d-block"}`}
        >
          {/* Banner */}
          <Banner bannerId="opportunities-banner">
            <Leading
              title="Nos opportunités"
              subtitle="Ressources et conseils"
            />
          </Banner>
          {/* <div className="searches-map">
                    <Maper
                        withPopup
                        // icon={mkSchool}
                        // items={filteredResults}
                        // redirectLink="/schools"
                        // zIndex={zIndex}
                    />
                </div> */}

          {/* Articles */}
          <Section
            // subtitle="À la Une"
            sectionId="opportunities-articles"
            sectionClasses="opportunities-articles py-5"
          >
            <div className="row">
              {articles.length > 0 ? (
                <div className="col-lg-12">
                  <SlideArticle items={articles} />
                  <div className="mt-3">
                    <a href="/articles" className="text-decoration-underline">
                      Voir tous les articles
                    </a>
                  </div>
                </div>
              ) : (
                <div className="empty-list text-center">
                  <p className="mb-0 p-2">
                    La liste de nos articles bientôt disponible.
                  </p>
                </div>
              )}
            </div>
          </Section>

          {/* Opportunities, Map */}
          <Section
            subtitle="Les Dernières Opportunités"
            sectionId="opportunities-last"
            sectionClasses="opportunities-last py-5"
            sectionInnerClasses=""
          >
            {opportunities.length > 0 ? (
              <>
                <div className="my-5">
                  <Maper
                    withPopup
                    icon={mkOpportunity}
                    items={opportunities}
                    redirectLink="/opportunites"
                  />
                </div>

                <div className="container mt-5">
                  <div className="row">
                    <div className="col-lg-12 mt-2 opportunities-filters">
                      <FilterOpportunity />
                    </div>
                    <div className="col-lg-12">
                      <ListOpportunity
                        items={opportunities}
                        listerClasses="g-3 mt-5"
                      />
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <div className="empty-list text-center">
                <p className="mb-0 p-2">
                  La liste de nos opportunités, à ne pas rater, bientôt
                  disponible.
                </p>
              </div>
            )}
          </Section>
        </div>
        </div>
      </React.Fragment>
    );
  }
}
Opportunities.propTypes = {
  opportunites: PropTypes.array,
  articles: PropTypes.array,
  onSetOpportunities: PropTypes.func,
  redirectToHomePage:PropTypes.func,
  onSetArticles: PropTypes.func,
  isPreloader: PropTypes.bool,
  tokenFailed: PropTypes.bool,
  tokenRetrieved: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  opportunities: state.opportunities,
  articles: state.articles,
  tokenRetrieved: state.tokenRetrieved,
  tokenFailed: state.tokenFailed,
  isPreloader: state.isPreloader,
});

const mapDispatchToProps = (dispatch) => ({
  onSetOpportunities: (data) => dispatch(setOpportunity(data)),
  onSetArticles: (data) => dispatch(setArticle(data)),
  onAppTokenAsked: (data) => dispatch(setAppTokenAsked(data)),
  onAppTokenRetrieved: (data) => dispatch(setAppTokenRetrieved(data)),
  onPreloaderToggled: (preload, message) =>
    dispatch(togglePreloader(preload, message)),
});
export default connect(mapStateToProps, mapDispatchToProps)(Opportunities);
